import styled, { css } from 'styled-components';

export const Banner = styled.div`
  ${({ theme }) => css`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    overflow: hidden;
    border-radius: ${theme.v3.border.radius.xl};
    padding: 0 48px;
    min-height: 200px;
    width: 100%;
    background: linear-gradient(
      135deg,
      ${theme.v3.colors.brand.snappyBlue[20]} 0%,
      ${theme.v3.colors.brand.snappyBlue[30]} 60%,
      ${theme.v3.colors.brand.snappyBlue[40]} 100%
    );

    @media (max-width: ${theme.v3.breakpoints.md}) {
      padding: 0 24px;
      flex-direction: column;
    }

    &::before {
      content: '';
      position: absolute;
      width: 500px;
      height: 500px;
      border-radius: 9999px;
      background: radial-gradient(circle, ${theme.v3.colors.brand.snappyBlue[40]} 0%, transparent 70%);
      left: -200px;
      bottom: -280px;
      opacity: 0.5;
      pointer-events: none;
    }

    &::after {
      content: '';
      position: absolute;
      width: 240px;
      height: 240px;
      border-radius: 9999px;
      background: radial-gradient(circle, ${theme.v3.colors.brand.snappyBlue[50]} 0%, transparent 70%);
      right: 60px;
      top: -100px;
      opacity: 0.4;
      pointer-events: none;
    }
  `}
`;

export const Content = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: 16px;
    align-items: flex-start;
    position: relative;
    z-index: 1;
    max-width: 620px;
    padding: 48px 0;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      padding: 24px 0;
    }
  `}
`;

export const Title = styled.h3`
  ${({ theme }) => css`
    font-size: ${theme.v3.font.sizes['1xlarge']};
    font-weight: ${theme.v3.font.weights.medium};
    line-height: 1.3;
    color: ${theme.v3.colors.neutral[100]};
    margin: 0;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      font-size: ${theme.v3.font.sizes['1xlarge']};
    }
  `}
`;

export const Description = styled.p`
  ${({ theme }) => css`
    font-size: ${theme.v3.font.sizes.medium};
    font-weight: ${theme.v3.font.weights.regular};
    line-height: ${theme.v3.font.lineHeight.comfortable};
    color: ${theme.v3.colors.neutral[100]};
    margin: 0;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      font-size: ${theme.v3.font.sizes.small};
    }
  `}
`;

export const DescriptionBold = styled.strong`
  ${({ theme }) => css`
    font-weight: ${theme.v3.font.weights.bold};
    color: ${theme.v3.colors.neutral[100]};
  `}
`;


export const ImageWrapper = styled.div`
  position: relative;
  z-index: 1;
  flex-shrink: 0;
  display: flex;
  align-items: flex-end;
  justify-content: center;
`;

export const BannerImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: bottom center;
`;
